import { useLandingPreferenceStore } from '@/stores/useLandingPreferenceStore';
import { toRouteParamNumberOrNull } from '@/utils/number.utils';
import { useWhoAmIStore } from '@/stores/useWhoAmIStore';
import { getCurrentTenant, getHasTenantAdminAccess } from '@/utils/role.utils';
import type { Router } from 'vue-router';

export default function setupLandingPreferenceTracking(router: Router): void {
  router.afterEach((to) => {
    const whoAmIStore = useWhoAmIStore();
    const whoAmI = whoAmIStore.whoAmI;
    if (!whoAmI?.id) return;

    const tenantId = getCurrentTenant(whoAmI)?.id;
    if (!tenantId) return;

    const landingPreferenceStore = useLandingPreferenceStore();

    if (to.path.startsWith('/class/')) {
      const classId = 'classId' in to.params ? toRouteParamNumberOrNull(to.params.classId) : null;
      landingPreferenceStore.setClassContext(whoAmI.id, tenantId, classId);
      return;
    }

    if (to.path.startsWith('/school/') && getHasTenantAdminAccess(whoAmI)) {
      landingPreferenceStore.setAdminContext(whoAmI.id, tenantId);
    }
  });
}
